import { Box, Card, Typography } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
  icon?: React.ReactNode;
  subtitle?: React.ReactNode;
  footer?: React.ReactNode;
  children?: any;
}

const PageTitle = (props: Props) => {
  return (
    <Card sx={{ padding: '10px', paddingBottom: props.footer ? 0 : '10px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {props.icon}
          <Box>
            <Typography variant="h2" component="h2" fontWeight={600}>
              {props.title}
            </Typography>
            {props.subtitle}
          </Box>
        </Box>
        {props.children}
      </Box>
      {props.footer}
    </Card>
  );
};

export default PageTitle;
